function FourOFour() {
  return (
    <div className="flex justify-center items-center py-24">
      <h1 className="text-4xl font-bold text-gray-700">Sorry, no page found</h1>
    </div>
  );
}

export default FourOFour;
